import { uniq } from "lodash";
import { sortDate } from "./dateTime";
import {
  Product,
  Scalars,
  Collection,
} from "nvs-types/dist/types/generated/contentful";

export function getCollectionRevealDates(collection: Collection) {
  const products = collection.productsCollection?.items as Product[];
  const revealDatesFromProducts = products?.reduce(
    (array: Scalars["DateTime"][], product: Product) => {
      if (product.revealDate) array.push(product.revealDate);
      return array;
    },
    [],
  );

  if (revealDatesFromProducts?.length < 1) return null;

  const uniqueDates = uniq<Scalars["DateTime"]>(revealDatesFromProducts);
  const sortedDates = uniqueDates.sort((a, b) => sortDate(a, b));

  return sortedDates;
}
